import * as actionTypes from '../actions/actionTypes';

const intialState = {
	loading : false,
	dispMsg : false,
	msgType : null,
	msg : null,
	isBoundary:false
}
// commonReducer
const commonReducer = (state = intialState, action) => {
	switch( action.type ) {
		case actionTypes.LOADER :
			return {
				...state,
				loading : (action.bool==='AUTO')?!state.loading:action.bool
			}
		case actionTypes.MESSAGES :
			return {
				...state,
				dispMsg : true,
				msgType: action.msgType,
				msg : action.msg,
			}
		case actionTypes.CLEAR_MESSAGES :
			return {
				...state,
				dispMsg : false,
				msgType: null,
				msg : null,
			}
		case actionTypes.BOUNDARY_WARNING:
			return{
				...state,
				isBoundary:action.bool
			}	
		default :
			return state;

	}
}

export default commonReducer;